document.addEventListener('DOMContentLoaded', function () {
  function replaceTag(node, tagName) {
    var replacement = document.createElement(tagName);
    Array.from(node.attributes).forEach(function (attribute) {
      replacement.setAttribute(attribute.name, attribute.value);
    });
    replacement.innerHTML = node.innerHTML;
    node.replaceWith(replacement);
    return replacement;
  }

  var main = document.querySelector('main');
  if (main) {
    var headings = Array.from(main.querySelectorAll('h1')).filter(function (heading) {
      return window.getComputedStyle(heading).display !== 'none';
    });
    headings.slice(1).forEach(function (heading) { replaceTag(heading, 'h2'); });
    if (headings.length === 0) {
      var pageHeading = document.createElement('h1');
      pageHeading.className = 'visually-hidden';
      pageHeading.textContent = document.title.split(/\s+[–|]\s+/)[0] || 'Page';
      main.prepend(pageHeading);
    }
  }

  document.querySelectorAll('.faq-accordion li h3').forEach(function (question, index) {
    var answer = question.nextElementSibling;
    if (!answer) return;
    if (!answer.id) answer.id = 'legacy-faq-answer-' + index;
    question.setAttribute('role', 'button');
    question.setAttribute('tabindex', '0');
    question.setAttribute('aria-controls', answer.id);
    question.setAttribute('aria-expanded', window.getComputedStyle(answer).display !== 'none' ? 'true' : 'false');
    var suppressSyntheticClick = false;
    question.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        event.stopPropagation();
        suppressSyntheticClick = true;
        var isOpen = window.getComputedStyle(answer).display !== 'none';
        answer.style.display = isOpen ? 'none' : 'block';
        question.parentElement.classList.toggle('active', !isOpen);
        question.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        window.setTimeout(function () { suppressSyntheticClick = false; }, 50);
      }
    });
    question.addEventListener('click', function (event) {
      if (suppressSyntheticClick) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      window.setTimeout(function () {
        question.setAttribute('aria-expanded', window.getComputedStyle(answer).display !== 'none' ? 'true' : 'false');
      }, 0);
    }, true);
  });

  document.querySelectorAll('.dot').forEach(function (dot, index) {
    dot.setAttribute('role', 'button');
    dot.setAttribute('tabindex', '0');
    if (!dot.getAttribute('aria-label')) dot.setAttribute('aria-label', 'Show slide ' + (index + 1));
    dot.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        dot.click();
      }
    });
  });
});
